import { Fragment, useContext, useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Container, Row, Col, Image, Stack, Button } from "react-bootstrap";
import useAxios from "axios-hooks";
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import StripeForm from "./StripeForm";
import BrandContext from "./BrandContext";
import { format } from 'date-fns'
const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_API_KEY);
export default function Checkout(props) {
    const theme = useContext(BrandContext);
    const nav = useNavigate();
    const params = useParams();
    const [status, setStatus] = useState(null);
    const [message, setMessage] = useState(null);

    const [{ data: currentPR, loading: loadingPR, error: prError }, refetchPR] = useAxios({
        method: 'get',
        url: '/pr/get',
        params: {
            id: params.prId
        },
    });
    useEffect(() => {
        // No valid pr found
        if (currentPR === null) {
            nav('../../');
            return;
        }
        const status = currentPR?.status;
        switch (status) {
            case 'submitted':
                nav('../submitted');
                return;
            default:
                break;
        }
        // Checkount wasn't completed, go back to cart
        if (currentPR && !currentPR?.checkout?.stripePaymentIntent?.clientSecret && currentPR?.checkout?.amount !== 0) {
            nav('../promote');
            return;
        }
        else if (currentPR && currentPR?.checkout?.stripePaymentIntent?.clientSecret && currentPR?.checkout?.amount !== 0) {
            stripePromise.then(stripe => {
                stripe.retrievePaymentIntent(currentPR.checkout.stripePaymentIntent.clientSecret).then(({ paymentIntent }) => {
                    switch (paymentIntent.status) {
                        case "succeeded":
                            setStatus("succeeded")
                            setMessage("Payment succeeded!");
                            break;
                        case "processing":
                            setStatus("processing")
                            setMessage("Your payment is processing...");
                            break;
                        case "requires_payment_method":
                            setStatus("initialized")
                            break;
                        default:
                            setStatus("error")
                            setMessage("Something went wrong.");
                            break;
                    }
                });
            })
        }
        else if (currentPR ?? currentPR?.checkout?.amount === 0) {
            setStatus("succeeded")
        }
    }, [currentPR, nav]);

    const [
        { loading: isCreatingDraft },
        executePut
    ] = useAxios(
        {
            url: '/pr/create',
            method: 'POST'
        },
        { manual: true }
    )
    function createDraft() {
        executePut({
            data: {
                customer: currentPR.customer,
                accountId: currentPR.accountId,
                brandId: currentPR.brandId
            }
        })
            .then((r) => {
                nav(`../../${r.data.id}/details`)
            })
            .catch((e) => {
                console.error(e)
            })
            .finally(() => {

            })
    }

    useEffect(() => {
    }, []);

    return (
        <Fragment>
            <Container fluid="md" style={{ paddingTop: "50px", paddingBottom: "50px" }}>
                <Row >
                    <Col sm={{ span: true, order: 'first' }} xs={{ span: 12, order: 'last' }} style={{ padding: "15px" }}>
                        <p style={{ fontSize: "14px" }}><span className="sr-light">Create</span> <span className="fw-bold text-swiftrev">&gt;</span> <span className="sr-light">Promote</span> <span className="fw-bold text-swiftrev">&gt;</span> <span className="fw-bold">Checkout</span></p>
                        <p className="fw-bold" style={{ fontSize: "24px", lineHeight: "26px" }}>Checkout</p>
                        {status && status !== 'succeeded' && <p>Once you click "purchase", your press release will be published at the selected date / time.</p>}
                    </Col>
                    <Col sm={{ span: 'auto', order: 'last' }} xs={{ span: 12, order: 'first' }} style={{ padding: "15px", display: "grid", alignContent: "start", justifyContent: "start" }}>
                        <Image style={{ height: "50px" }} fluid src={theme?.marketing?.logo}></Image>
                    </Col>
                </Row>
                <Row >
                    <Col md={{ span: 8, order: 'first' }} xs={{ span: 12, order: 'last' }} style={{ padding: "15px" }}>
                        {
                            currentPR?.checkout?.stripePaymentIntent?.clientSecret && status &&
                            <Elements stripe={stripePromise} options={{ clientSecret: currentPR?.checkout?.stripePaymentIntent?.clientSecret }}>
                                <StripeForm currentPR={currentPR} status={status} message={message} />
                            </Elements>
                        }
                        {status === 'succeeded' && <div>
                            <p><span style={{ fontWeight: "bold" }}>Your purchase is complete!</span> A copy of your order has been emailed to you.</p>
                            <p>Your press releases will be available at the link(s) below after {format(new Date(currentPR.prPostDate), 'PPpp')}:</p>
                            {(currentPR?.checkout?.cart || []).map(i => {
                                return <Stack key={i.brandId} direction="horizontal">
                                    <a target="_blank" rel="noreferrer" href={i.prUrl}>{i.brandName} Press Release</a>
                                </Stack>
                            })}
                        </div>}
                        {status === 'error' && <div className="text-danger" id="payment-message">{message}</div>}
                        {status === 'processing' && <div id="payment-message">{message}</div>}
                    </Col>
                    <Col md={{ span: 4, order: 'last' }} xs={{ span: 12, order: 'first' }} style={{ paddingTop: "15px", paddingLeft: "25px", paddingRight: "25px" }}>
                        {status &&
                            <Fragment>
                                <h4 className="fw-bold">Purchase Summary</h4>
                                {(currentPR?.checkout?.cart || []).map(i => {
                                    return <Stack key={i.brandId} direction="horizontal">
                                        <div>{i.brandName}</div>
                                        <div className="ms-auto">{theme?.priceSymbol}{i.price} {theme?.priceAbbr}</div>
                                    </Stack>
                                })}
                                <hr />
                                <Stack direction="horizontal">
                                    <div className="fw-bold">Total</div>
                                    <div className="ms-auto fw-bold">{theme?.priceSymbol}{currentPR?.checkout?.amount} {theme?.priceAbbr}</div>
                                </Stack>
                            </Fragment>
                        }
                    </Col>
                </Row>
                <Row>
                    <Col xs="auto" style={{ paddingTop: "25px" }}>
                        {currentPR && status === 'succeeded' && <Button disabled={!currentPR} onClick={() => createDraft()} variant="outline-swiftrev">
                            Post Another Press Release
                        </Button>}
                    </Col>
                </Row>
            </Container>
        </Fragment>
    );
}